<template>
  <module-configuration :data="config" :errors="errors">
    <div slot="auth" class="l-row">
      <form-group label="Ambiente" :required="true">
        <select v-model="config.auth.environment" class="form-select">
          <option value="sandbox">Sandbox</option>
          <option value="production">Produção</option>
        </select>
      </form-group>
      <form-group label="Username">
        <input class="form-input" v-model="config.auth.username">
      </form-group>
      <form-group label="Password">
        <input class="form-input" type="password" v-model="config.auth.password">
      </form-group>
      <form-group label="Token" :columns="6" v-if="config.auth.token">
        {{ config.auth.token.substring(0, 50) }}...
        <button type="button" @click="copied()" class="btn btn--sm btn--info copy hint hint--top" data-label="Clique para copiar" v-clipboard:copy="config.auth.token">
          <i class="icon icon-copy2"></i> 
        </button>
      </form-group>
    </div>
    
    <panel title="Produtos">
      <div class="l-row">
        <product-price-configuration :input="config.product.price"/>
        <form-group label="Redutor de estoque padrão">
          <input class="form-input" min="0" type="number" v-model="config.product.stock.reducer">
        </form-group>

        <form-group label="Webhook notificação de produto " :columns="6">
          {{ urlWebhookProductNotification }}

          <button type="button" class="btn btn--sm btn--info copy hint hint--top" data-label="Clique para copiar" v-clipboard:copy="urlWebhookProductNotification">
            <i class="icon icon-copy2"></i>
          </button>
        </form-group>
      </div>
    </panel>

    <panel title="Pedidos">
      <div class="l-row">
        <form-group label="Webhook notificação de pedidos " :columns="6">
          {{ urlWebhookOrderNotification }}

          <button type="button" class="btn btn--sm btn--info copy hint hint--top" data-label="Clique para copiar" v-clipboard:copy="urlWebhookOrderNotification">
            <i class="icon icon-copy2"></i>
          </button>
        </form-group>
      </div>
    </panel>

    <panel :title="$t('quotation.label')">
      <div class="l-row">
        <div class="l-col-6@md">
          <quotation-configuration :quotation="config.quotation" :marketplace="identifier"/>
        </div>
      </div>
    </panel>

    <panel :title="$t('expediter.label')">
      <expediter-configuration :expediter="config.order.expediter"/>
    </panel>

    <panel :title="$t('order.label')">
      <order-retrieve-date-configuration :orderConfigs="config.order"/>
    </panel>
  </module-configuration>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ModuleConfiguration from '@/views/Configuration/Shared'
  import FormGroup from '@/components/template/FormGroup'
  import notifier from '@/notifier'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'
  import ProductPriceConfiguration from '@/components/shared/ProductPriceConfiguration'
  import ExpediterConfiguration from '@/components/marketplace/shared/ExpediterConfiguration'
  import QuotationConfiguration from '@/components/marketplace/shared/QuotationConfiguration'
  import OrderRetrieveDateConfiguration from '@/components/marketplace/shared/OrderRetrieveDateConfiguration'
  import cookie from 'vue-cookie'

  export default {
    inject: ['expeditersDI', 'priceTypeDI'],
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'renner'
      }
    },
    data: () => ({
      errors: [],
      type: 'marketplace',
      identifier: 'renner',
      config: {
        auth: {
          environment: 'sandbox',
          username: null,
          password: null
        },
        product: {
          price: {
            type: null,
            percent: null
          },
          stock: {
            reducer: 0
          }
        },
        order: {
          expediter: {
            type: null,
            identifier: null
          },
          retrieveDate: null
        },
        quotation: {
          shipmentMethod: null
        },
        webhook: {
          sellerId: null
        }
      }
    }),
    watch: {
      'config.product.stock.reducer' (value) {
        this.config.product.stock.reducer = parseInt(value)
      }
    },
    methods: {
      copied () {
        notifier.success('Token copiado com sucesso!', 'Sucesso')
      }
    },
    computed: {
      ...mapGetters('module', [
        'definitionEcommerceInstalled'
      ]),
      urlWebhookProductNotification () {
        let url = `https://backend.placemarket.com.br/webhook/marketplace/renner/product_notification/${cookie.get('merchant')}`

        if (window.location.hostname === 'localhost') {
          url = `http://localhost:3001/webhook/marketplace/netshoes/product_notification/${cookie.get('merchant')}`
        }

        return url
      },
      urlWebhookOrderNotification () {
        let url = `https://backend.placemarket.com.br/webhook/marketplace/renner/order_notification/${cookie.get('merchant')}`

        if (window.location.hostname === 'localhost') {
          url = `http://localhost:3001/webhook/marketplace/netshoes/order_notification/${cookie.get('merchant')}`
        }

        return url
      }
    },
    components: {
      OrderRetrieveDateConfiguration,
      FormGroup,
      ModuleConfiguration,
      Panel,
      Loader,
      ProductPriceConfiguration,
      ExpediterConfiguration,
      QuotationConfiguration
    }
  }
</script>



// WEBPACK FOOTER //
// Renner.vue?0a9c9d0c